module.exports = __webpack_public_path__ + "8748f12107b40bf608fac190530cda5b.svg";